import { Button, FormControl, FormLabel, Input, Stack } from '@chakra-ui/react'

interface AddHelpFormProps {
  question: string
  answer: string
  onQuestionChange: (value: string) => void
  onAnswerChange: (value: string) => void
  onSubmit: (e: React.FormEvent) => void
}

export const AddHelpForm = ({
  question,
  answer,
  onQuestionChange,
  onAnswerChange,
  onSubmit,
}: AddHelpFormProps) => {
  return (
    <form onSubmit={onSubmit}>
      <Stack spacing={4}>
        <FormControl>
          <FormLabel>Question</FormLabel>
          <Input
            required
            value={question}
            onChange={(e) => onQuestionChange(e.target.value)}
            placeholder='Enter a question...'
          />
        </FormControl>
        <FormControl>
          <FormLabel>Answer</FormLabel>
          <Input
            required
            value={answer}
            onChange={(e) => onAnswerChange(e.target.value)}
            placeholder='Enter an answer...'
          />
        </FormControl>
        <Button type='submit'>Create</Button>
      </Stack>
    </form>
  )
}
